import { render, staticRenderFns } from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=template&id=60b30ba1&scoped=true&lang=html"
import script from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=style&index=0&id=60b30ba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b30ba1",
  null
  
)

export default component.exports